import React from 'react'
import { Button, Icon } from 'ui-framework'
import { isFinite } from 'lodash'

type Position = 'top' | 'right' | 'bottom' | 'left'
const positionProps: Position[] = ['top', 'right', 'bottom', 'left']

function getPositionStyle(props: Partial<Record<Position, number>>) {
  return positionProps.reduce((acc, pos) => {
    if (isFinite(props[pos])) {
      acc.position = 'absolute'
      acc[pos] = props[pos]
    }
    return acc
  }, {} as any)
}

export function ButtonClose(props: any) {
  return (
    <Button
      variant="invisible"
      className="z-100"
      aria-label="Close Dialog"
      style={getPositionStyle(props)}
      {...props}>
      <Icon name="cross" color="var(--color-txt-muted)" size={32} bgPadding={8} />
    </Button>
  )
}

export default React.memo(ButtonClose)
